import { render, staticRenderFns } from "./DepartmentConfig.vue?vue&type=template&id=3bf4d587&scoped=true"
import script from "./DepartmentConfig.vue?vue&type=script&lang=js"
export * from "./DepartmentConfig.vue?vue&type=script&lang=js"
import style0 from "./DepartmentConfig.vue?vue&type=style&index=0&id=3bf4d587&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf4d587",
  null
  
)

export default component.exports